import React, { useEffect, useState, ReactNode } from "react";
import { useTranslation } from "react-i18next";
type InputInlineWidgetPropsType = {
  value?: any;
  type?: string;
  title?: string;
  placeholder?: string;
  className?: string;
  autoFocus?: boolean;
  border?: boolean;
  readOnly?: boolean;
  error?: boolean;
  onFinish?: (value: string, save?: boolean) => void;
  onChange?: (value: string) => void;
  onClick?: () => void;
  onEdit?: (value: boolean) => void;
  rightAction?: ReactNode;
};

const InputInlineWidget = (props: InputInlineWidgetPropsType) => {
  const { t } = useTranslation();
  const {
    onFinish,
    value = "",
    placeholder,
    className = "",
    autoFocus = false,
    error = false,
    border = false,
    onEdit = () => {},
    onChange = () => {},
    rightAction,
    readOnly = false,
    type = "text",
  } = props;

  const [inputValue, setInputValue] = useState(value);

  const handleOnChange = (e) => {
    setInputValue(e.target.value);
    onChange(e.target.value);
    onEdit(true);
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      handleOnFinish();
    }
  };

  const handleOnFinish = () => {
    if (inputValue !== value && onFinish) {
      onFinish(inputValue, true);
      onEdit(false);
    }
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const borderStyle = border ? "outline-1 -outline-offset-1 outline-gray-300" : "";
  const errorStyle = error
    ? " text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-red-600"
    : "";

  return (
    <div className={`flex items-center w-full -ml-3 ${borderStyle} ${errorStyle}`}>
      <input
        type={type}
        className={`block w-full rounded-md bg-white px-3 py-1 ${className} focus:outline-2 focus:-outline-offset-2 ${
          readOnly ? "cursor-not-allowed" : ""
        }`}
        value={inputValue}
        placeholder={placeholder ? t(placeholder) : undefined}
        onChange={handleOnChange}
        onBlur={handleOnFinish}
        onKeyDown={handleKeyPress}
        autoFocus={autoFocus}
        readOnly={readOnly}
      />
      {rightAction}
    </div>
  );
};

export default InputInlineWidget;
